// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";
import {
  type VectorStyleFile,
  VectorStyleFileFromJSON,
  VectorStyleFileToJSON,
} from "../models/VectorStyleFile";

export interface GetVectorStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  fileName: VectorStyleFile;
}

export interface PublicationGetVectorStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  fileName: VectorStyleFile;
}

export interface UpdateVectorStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
}

/**
 *
 */
export class VectorsApi extends runtime.BaseAPI {
  /**
   * Creates request options for getVectorStyle without sending the request
   * @deprecated
   */
  async getVectorStyleRequestOpts(
    requestParameters: GetVectorStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getVectorStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling getVectorStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling getVectorStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/vector-style/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the vector\'s style or sprite files
   * @deprecated
   */
  async getVectorStyleRaw(
    requestParameters: GetVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.getVectorStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the vector\'s style or sprite files
   * @deprecated
   */
  async getVectorStyle(
    requestParameters: GetVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.getVectorStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationGetVectorStyle without sending the request
   * @deprecated
   */
  async publicationGetVectorStyleRequestOpts(
    requestParameters: PublicationGetVectorStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationGetVectorStyle().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationGetVectorStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling publicationGetVectorStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling publicationGetVectorStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/file-descriptors/{file_descriptor_id}/vector-style/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the vector\'s style or sprite files
   * @deprecated
   */
  async publicationGetVectorStyleRaw(
    requestParameters: PublicationGetVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.publicationGetVectorStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the vector\'s style or sprite files
   * @deprecated
   */
  async publicationGetVectorStyle(
    requestParameters: PublicationGetVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.publicationGetVectorStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for updateVectorStyle without sending the request
   * @deprecated
   */
  async updateVectorStyleRequestOpts(
    requestParameters: UpdateVectorStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling updateVectorStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling updateVectorStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/vector-style`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * DEPRECATED - use the POST /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles endpoint instead.  The styling of the vector layers in this vector file can be set using a style.json file conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/.  Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.
   * retrieve urls to update the vector\'s style
   * @deprecated
   */
  async updateVectorStyleRaw(
    requestParameters: UpdateVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    const requestOptions = await this.updateVectorStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * DEPRECATED - use the POST /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles endpoint instead.  The styling of the vector layers in this vector file can be set using a style.json file conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/.  Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.
   * retrieve urls to update the vector\'s style
   * @deprecated
   */
  async updateVectorStyle(
    requestParameters: UpdateVectorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: string }> {
    const response = await this.updateVectorStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
